// UpdateModalOk.tsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import BaseModal from './BaseModal';

export interface UpdateModalOkProps {
  show: boolean;
  onClose: () => void;
  onSave: () => void; // OK 押下時
}

const UpdateModalOk: React.FC<UpdateModalOkProps> = ({
  show,
  onClose,
  onSave,
}) => {
  return (
    <BaseModal show={show} onHide={onClose}>
      {/* ヘッダー（保存系＝primary） */}
      <Modal.Header className="bg-primary text-white justify-content-center">
        <Modal.Title as="h5" className="w-100 text-center m-0">
          更新の確認
        </Modal.Title>
      </Modal.Header>

      {/* 本文 */}
      <Modal.Body className="text-center mt-5 mb-5">
        <div>内容を更新しますか？</div>
      </Modal.Body>

      {/* フッター */}
      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={onClose}>
          キャンセル
        </Button>
        <Button variant="primary" onClick={onSave}>
          OK
        </Button>
      </Modal.Footer>
    </BaseModal>
  );
};

export default UpdateModalOk;
